import httpClient, { GET } from 'providers/http'

/**
 * @param {{ signal: AbortSignal }}
 */
export async function fetcRoles({ signal }) {
  return await httpClient({
    endpoint: '/api/v1/roles',
    method: GET,
    signal,
    requiresAuth: true
  })
}
